import PropTypes from "prop-types";
import { createContext, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getBase64ProfileImage } from "src/services/helperService";
import { getToken } from "src/services/loginService";
import { getProfileImage } from "src/services/userService";

export const UserContext = createContext();
export const localStorageEventHandler = new CustomEvent(
  "localStorageEventHandler",
  null
);

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState({
    userId: 0,
    username: "",
    displayName: "",
    profileImage: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const handleStorageChange = async () => {
      const user = await getData();

      if (user) {
        setUser(user);
        dispatch({ type: "set", isAuthenticated: true });
      } else {
        dispatch({ type: "set", isAuthenticated: false });
        navigate("/login");
      }
    };

    window.addEventListener("localStorageEventHandler", handleStorageChange);
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(
        "localStorageEventHandler",
        handleStorageChange
      );
    };
  }, []);

  const getData = async () => {
    try {
      const token = getToken();

      if (token) {
        const userId =
          token[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
          ];
        const username = token ? token["Name"] : 0;

        let { data } = await getProfileImage(userId);

        return {
          userId: userId ?? 0,
          username: username,
          displayName: token?.DisplayName,
          profileImage: "",
          profileImage: getBase64ProfileImage(data?.ProfileImage),
        };
      }
    } finally {
    }
    return null;
  };

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

UserContextProvider.propTypes = {
  children: PropTypes.node,
};

export const useUser = () => useContext(UserContext);
